import React from "react";
import CustomToolTip from './ToolTip';
import './TooltipDataviewEmployee.scss';

export default function TooltipDataviewEmployee(props) {

    let { listCol, data, employeeName = '' } = props;

    let tooltipEE =
        <React.Fragment>
            <div className="tdv-cell-tooltip">
                <div className="tdv-header-container">
                    <span>{employeeName}</span>
                </div>
                <table className="tdv-body-container">
                    <tbody>
                        {

                            listCol.map((col) => {
                                let matches = data.filter(d => d.key === col.DataviewKey)
                                if (matches.length === 0) {
                                    return null
                                }

                                // Assignment-specific field: one row per assignment, labelled with the assignment name.
                                let assignmentMatches = matches.filter(d => d.assignmentId)
                                if (assignmentMatches.length > 0) {
                                    return assignmentMatches
                                        .slice()
                                        .sort((a, b) => ((a.assignmentName || '') < (b.assignmentName || '') ? -1 : 1))
                                        .map(field => (
                                            <tr key={`${col.DataviewKey}-${field.assignmentId}`}>
                                                <td className="tdv-genie-header">{`${col.Label} (${field.assignmentName || field.assignmentId})`}</td>
                                                <td className="tdv-genie-data">{field.rawValue}</td>
                                            </tr>
                                        ))
                                }

                                let field = matches[0]
                                return (
                                    <tr key={col.DataviewKey}>
                                        <td className="tdv-genie-header">{col.Label}</td>
                                        <td className="tdv-genie-data">{field.rawValue}</td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
        </React.Fragment>

    return (
        <CustomToolTip
            style={{ width: '100%' }}
            titleText={tooltipEE}
            jsx={
                <div className="tdv-name-section">
                    <div className="tdv-name-text">{employeeName}</div>
                </div>
            }
        />
    );
}